import { useContext, useEffect, useState } from "react";
import { dataa } from "../../context/data";
import "../../style/components/FormAddInInvenotry.css";
import { switchh } from "../../context/switch";
import { intialData } from "../../context/initial";
import { useTranslation } from "react-i18next";
import useCreationInventoryService from "../../funcs/hooks/inventory.service/useCreatingBatch";
import useUpdateInventoryService from "../../funcs/hooks/inventory.service/useAddOneBatch";
import { mainSearch } from "../indexDB/indexDBStora";

export default function FormAddProductInventroy(props) {
    const inventory = props.inventory;
    
    const { createInitBatch, transactionOnBatch } = useContext(intialData);
    const { products, suppliers } = useContext(dataa);
    const { setEnableAddInInvenotry, loadingProcess } = useContext(switchh);
    
    const { t } = useTranslation();
    const { createBatch, getAllBatches } = useCreationInventoryService();
    const { AddOnBatch } = useUpdateInventoryService();
    
    const [newTransactionOnBatch, setNewTransactionOnBatch] = useState(transactionOnBatch());
    const [saveProductInv, setSaveProductInv] = useState(createInitBatch());

    
    const [isNewBatch, setIsNewBatch] = useState(false);
    const [batches, setBatches] = useState([]);
    const [product,setProduct] = useState({});
    const [type, setType] = useState("");
    const [boxes, setBoxes] = useState(0);

    const handleChange = (e, mode = "batch") => {
    const { name, value } = e.target;

    const numberFields = ["buyPrice", "qty"];
    
    let parsedValue = value;

    if (numberFields.includes(name)) {
        parsedValue = value.replace(/[^0-9.]/g, "");
        const parts = parsedValue.split(".");
        if (parts.length > 2) {
            parsedValue = parts[0] + "." + parts.slice(1).join("");
        }
        if (parsedValue === ".") parsedValue = "0.";
    }

    if (mode === "batch") {
        setSaveProductInv(prev => ({
            ...prev,
            [name]: parsedValue,
        }));
    } else {
        setNewTransactionOnBatch(prev => ({
            ...prev,
            [name]: parsedValue,
        }));
    }
};
    // nested state helper
    const handleNestedChange = (parent, field, value) => {
        setSaveProductInv((prev) => ({
            ...prev,
            [parent]: {
                ...prev[parent],
                [field]: value,
            },
        }));
    };

    // display batches of product
    useEffect(() => {
        const Display = async () => {
            const id = saveProductInv.productId;
            const batches = await getAllBatches(id);
            setBatches(batches);
        }

        Display();
    }, [saveProductInv.productId, loadingProcess]);


    const Reset = () => {
        setSaveProductInv(createInitBatch());
        setNewTransactionOnBatch(transactionOnBatch());
        setIsNewBatch(false);
    }

    const getLastIndex = () => {
        const lastIndex = batches?.length
        ? Math.max(...batches.map(b => b.index ?? 0))
        : -1;
        return lastIndex + 1;
    }

    const HandllingBatches = (e) => {
        e.preventDefault();
        if(loadingProcess) return;
        const meta = {
            type: type,
            boxes: Number(boxes) || 1
        }
        if(isNewBatch) {
            const index = getLastIndex();
            createBatch(saveProductInv, newTransactionOnBatch, index, product, inventory, meta, Reset);
        } 
        else {
            AddOnBatch(newTransactionOnBatch,meta, Reset);
        }
    }

    useEffect(() => {
        if (!saveProductInv.productId) {
            setProduct({});
            setBatches([]);
            return;
        }

        let ignore = false;

        const load = async () => {
            const [productData, batchesData] = await Promise.all([
                mainSearch("products", saveProductInv.productId),
                getAllBatches(saveProductInv.productId)
            ]);

            if (ignore) return;

            setProduct(productData || {});
            setBatches(batchesData || []);
        };

        load();

        return () => {
            ignore = true;
        };
    }, [saveProductInv.productId]);

    return (
        <div className="container-box addInInventory fixed flex flex-center-center">
            <div className="box">
                <h3 className="center">{inventory.name}</h3>
                
                <button
                onClick={() => setEnableAddInInvenotry({})}
                className="close">x</button>

                <form onSubmit={HandllingBatches}>
                    {/* Product + Type */}
                    <div className="sec flex">
                        <div className="ch">
                            <label>ضيف المنتج بالمخزن</label>
                            <select
                                className="pad-10"
                                name="productId"
                                value={saveProductInv.productId}
                                onChange={(e) => {
                                    handleChange(e)
                                    setType("");
                                }}
                            >
                                <option value="" disabled>
                                    حدد المنتج
                                </option>

                                {products?.map((product) => (
                                    <option disabled={
                                        product.inventoryId.length !== 0 && product.inventoryId !== inventory.id
                                    } key={product.id} value={product.id}>
                                        {`${product.nameProudct} -- ${product.sellPrice}`}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="ch">
                            <label>حدد الدفعة من هنا</label>
                            <select
                            value={newTransactionOnBatch.batchId}
                            className="pad-10" 
                            onChange={(e) => {
                            const value = e.target.value;
                            if (value === "new") {
                                setIsNewBatch(true);
                                setNewTransactionOnBatch((prev) => ({
                                    ...prev,
                                    batchId: "",
                                    transactionType: "IN",
                                    qty: 0
                                }));
                                return;
                            }

                            setIsNewBatch(false);
                            setNewTransactionOnBatch((prev) => ({
                                ...prev,
                                batchId: value
                            }));
                        }}
                            disabled={!saveProductInv.productId}>
                                <option value={''} disabled>أختار الدفعة</option>
                                {batches.length !== 0 && batches.map((batch, key) => 
                                <option key={key} value={batch.id}>{batch.name} - {batch?.meta?.createdAt}</option>
                                )}
                                <option value={'new'}>ضيف دفعة جديدة +</option>
                            </select>
                        </div>
                    </div>
                    {isNewBatch &&
                        <div className="batch-data">
                            <div className="sec">
                                <label>اسم للدفعة</label>
                                <input
                                    name="name"
                                    value={saveProductInv.name || ""}
                                    onChange={(el) => handleChange(el)}
                                    className="inp"
                                    type="text"
                                    placeholder="اختر اسم للدفعة الجديدة"
                                />
                            </div>
                            {/* Prices */}
                            <div className="flex sec">
                                <div className="ch">
                                    <label>السعر الشراء الحالي</label>
                                    <input
                                        name="buyPrice"
                                        className="inp"
                                        type="text"
                                        inputMode="decimal"
                                        value={saveProductInv.buyPrice}
                                        onChange={handleChange}
                                    />
                                </div>
                                    <div className="ch">
                                    <label>إنتهاء الصلاحيه</label>
                                    <input
                                    onChange={(e) =>
                                            handleNestedChange(
                                                "meta",
                                                "expiredDate",
                                                e.target.value
                                            )
                                        }
                                    className="inp" type="date" value={saveProductInv.meta.expiredDate} />
                            </div>
                                <div className="ch">
                                    <label>الشركة الموردة</label>
                                    <select 
                                        value={saveProductInv.meta.supplierId}
                                        onChange={(e) =>
                                            handleNestedChange(
                                                "meta",
                                                "supplierId",
                                                e.target.value
                                            )
                                        }
                                        className="pad-10">
                                        <option>اضف المورد</option>
                                        {suppliers.map((supp, key) =>
                                            <option key={key} value={supp.id}>{supp.supplierCompany}</option>
                                        )}
                                    </select>
                                </div>
                            </div>
                        </div>
                    }
                    {saveProductInv && saveProductInv?.productId &&
                        <div>
                            <div className="flex sec">
                            <div className="ch">
                            <label>{type === "box" ? "الصندوق الواحد" : "الكمية"}</label>
                            <input
                                className="inp"
                                type="number"
                                min={1}
                                value={newTransactionOnBatch.qty}
                                onChange={(e) =>
                                    setNewTransactionOnBatch((prev) => ({
                                        ...prev,
                                        qty: Number(e.target.value),
                                    }))
                                }
                            />
                            </div>
                            {product && 
                                <div className='ch'>
                                    <label className='imp'>{t("label:product.measuringUnit.label")}</label>
                                    <select
                                        className="pad-10"
                                        name="unit"
                                        value={type}
                                        onChange={(e) => setType(e.target.value)}
                                    >
                                        <option disabled value={''}>{t("label:product.measuringUnit.chooseUnit")}</option>
                                        {product.type === "weight" ?
                                        <>
                                            <option value={"G"}>{t("unit:gram")}</option>
                                            <option value={"KG"}>KG</option>
                                        </>
                                        :
                                        <>
                                            <option value={"piece"}>piece</option>
                                            <option value={"box"}>box</option>
                                        </>
                                        }
                                    </select>
                                </div>
                            }
                            </div>
                            <div className="sec flex">
                                <div className="ch">
                                    <label>الحركة</label>
                                    <select
                                        className="pad-10"
                                        name="transactionType"
                                        value={newTransactionOnBatch.transactionType}
                                        onChange={(el) => handleChange(el, "transaction")}
                                    >
                                        <option value="IN">IN</option>
                                        <option disabled={isNewBatch} value="OUT">OUT</option>
                                        <option disabled={isNewBatch} value="ADJUSTMENT">ADJUSTMENT</option>
                                    </select>
                                </div>
                                {type === "box" &&
                                    <div className="ch">
                                        <label>عدد الصندايق</label>
                                        <input value={boxes} onChange={(e) => setBoxes(e.target.value)} className="inp" type="number" />
                                    </div> 
                                }
                            </div>
                        </div>
                    }
                    <button type="submit">
                        {isNewBatch ? "تسجيل دفعة جديدة" : "تسجيل حركة جديدة"}
                    </button>
                </form>

            </div>
        </div>
    );
}